import { Link, NavLink, useNavigate } from "react-router-dom";
import { Ear, LogOut, Home } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";
import { Button } from "./ui/button";

export default function DashboardLayout({ title, subtitle, nav = [], children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const handleLogout = async () => { await logout(); navigate("/"); };

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="bg-primary-blue text-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-white text-primary-blue flex items-center justify-center">
              <Ear size={20} />
            </div>
            <div>
              <div className="font-heading text-lg">Audition Expert</div>
              <div className="text-xs text-white/70 uppercase tracking-widest">{subtitle}</div>
            </div>
          </Link>
          <div className="flex items-center gap-3">
            <Link to="/"><Button variant="ghost" className="text-white hover:bg-white/10"><Home size={16} className="mr-2" /> Site public</Button></Link>
            <div className="hidden md:block text-sm text-white/80">
              {user?.first_name} {user?.last_name} · <span className="text-gold">{user?.role}</span>
            </div>
            <Button onClick={handleLogout} variant="ghost" className="text-white hover:bg-white/10" data-testid="dash-logout"><LogOut size={16} className="mr-2" /> Déconnexion</Button>
          </div>
        </div>
      </header>
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-8">
        <div className="grid lg:grid-cols-[240px_1fr] gap-8">
          <aside className="lg:sticky lg:top-6 h-max">
            <div className="bg-white rounded-2xl border border-slate-200 p-3">
              <div className="px-3 py-2 font-heading text-lg text-primary-blue">{title}</div>
              <nav className="mt-1 flex flex-col gap-1">
                {nav.map((n) => (
                  <NavLink
                    key={n.to}
                    to={n.to}
                    end={n.end}
                    className={({ isActive }) => `px-3 py-2.5 rounded-md text-sm font-medium transition-colors ${isActive ? "bg-primary-blue text-white" : "text-slate-700 hover:bg-sky-blue"}`}
                    data-testid={`dashnav-${n.to.replace(/\//g, "-")}`}
                  >
                    {n.label}
                  </NavLink>
                ))}
              </nav>
            </div>
          </aside>
          <main className="min-w-0">{children}</main>
        </div>
      </div>
    </div>
  );
}
